import { TGetUserDto } from "@/api/services/admin/rso/user/dtos/get-user.dto";
import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { dayjs } from "@/utils/dayjs";
import { TCreateRSOReqDto } from "@/api/services/admin/rso/dtos/create-match.dto";
import { TUpdateRSOReqDto } from "@/api/services/admin/rso/dtos/update-match.dto";
import { TPartnerForm } from "@/features/rso/types/partnerForm";
import { TGetRSODto } from "@/api/services/admin/rso/dtos/get-match.dto";
import { TUpdatePartnerUserForm } from "@/features/rso/types/updatePartnerUserForm";
export const convertPartnerFormToCreateReq = (data: TPartnerForm): TCreateRSOReqDto => {
  return {
    name: data.name,
    licenseNumber: data.licenseNumber,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    webAccessEnabled: data.webAccessEnabled ?? false,
  };
};

export const convertPartnerFormToUpdateReq = (data: TPartnerForm): TUpdateRSOReqDto => {
  return {
    name: data.name,
    licenseNumber: data.licenseNumber ?? null,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate ? data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) : null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    webAccessEnabled: data.webAccessEnabled ?? false,
  };
};

export const convertPartnerResToForm = (data: TGetRSODto): Partial<TPartnerForm> => {
  return {
    id: data.id,
    name: data.name,
    licenseNumber: data.licenseNumber || "",
    contractStatus: data.contractStatus ?? "",
    contractPlan: data.contractPlan ?? "",
    description: data.description ?? "",
    note: data.note ?? "",
    trialStartDate: data.trialStartDate ? dayjs(data.trialStartDate) : null,
    trialEndDate: data.trialEndDate ? dayjs(data.trialEndDate) : null,
    contractEndDate: data.contractEndDate ? dayjs(data.contractEndDate) : null,
    contractStartDate: data.contractStartDate ? dayjs(data.contractStartDate) : null,
    webAccessEnabled: data.webAccessEnabled ?? false,
  };
};

export const convertPartnerUserResToForm = (data: TGetUserDto): Partial<TUpdatePartnerUserForm> => {
  return {
    email: data.email,
    fullName: data.fullName,
    isUser: Number(data.isMatchUser ?? data.isUser ?? 0),
    activeStatus: data.activeStatus ?? null,
  };
};
